import React from 'react'
import { Coins } from 'lucide-react'

import { useMember } from '@rewardops/auth'
import MetricCard from '@rewardops/replit/src/components/MetricCard'

import { PAWSectionType } from './paw-section-types'

export const PoinstBalanceSection: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const member = useMember()
  return (
    <div
      id={content?.sectionId}
      data-testid={content?.sectionId}
      className="lg:col-span-4"
    >
      <MetricCard
        title={content?.title ?? 'Points Bank Balance'}
        value={member?.points ?? 0}
        subtitle={content?.subtitle ?? ''}
        icon={Coins}
        variant="earnings"
        className="h-full"
      />
    </div>
  )
}
